import * as types from '@/redux/actionTypes';

const initState = {
  applyIdToComment: {},
};

function comments(state = initState, { type, payload }) {
  switch (type) {
    case types.UPDATE_COMMENTS: {
      const applyIdToComment = { ...state.applyIdToComment, ...payload };
      return {
        ...state,
        applyIdToComment,
      };
    }

    case types.UPDATE_ALL_COMMENTS: {
      payload = payload || [];
      const applyIdToComment = payload.reduce((obj, item) => {
        obj[item.applicationId] = { ...state.applyIdToComment[item.id], ...item };
        return obj;
      }, {});
      return {
        ...state,
        applyIdToComment,
      };
    }

    default:
      return state;
  }
}

export default comments;
